import type { ListingItem } from "@/hooks/use-paginated-feed";

export function discoverTypeLabelFromListing(item: ListingItem): string {
  const scheduled = item.scheduled_publish_at;
  if (scheduled) {
    const t = new Date(scheduled).getTime();
    if (!Number.isNaN(t) && t > Date.now()) {
      return "Scheduled";
    }
  }
  if ((item as { type?: string | null }).type === "preorder") return "Pre-order";
  const f = item.listing_format;
  if (f === "auction") return "Auction";
  if (f === "offers_only") return "Offers";
  if (f === "fixed_price_with_offers") return "Buy now";
  if (f === "fixed_price") return "Buy now";
  return "Buy now";
}
